import 'babel-polyfill'
// vue.js
import 'filedrop'
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/vuex/store'
import filters from '@/util/filters'
import { CLEAR_MODALS } from '@/vuex/types'
import 'choices.js/assets/styles/css/choices.min.css'

// Plugins
import Vuex from 'vuex'
import UserPlugin from './userPlugin.js'
import GlobalDirectives from './globalDirectives'

Vue.use(GlobalDirectives)
Vue.use(Vuex)
Vue.use(UserPlugin)

Vue.config.productionTip = false

for (let filter in filters) {
  Vue.filter(filter, filters[filter])
}

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

router.afterEach((to, from) => {
  app.$store.commit(CLEAR_MODALS)
})

export { app }



// WEBPACK FOOTER //
// ./src/main.js